import { render, staticRenderFns } from "./shopmanagement.vue?vue&type=template&id=231e3876&scoped=true"
import script from "./shopmanagement.vue?vue&type=script&lang=ts"
export * from "./shopmanagement.vue?vue&type=script&lang=ts"
import style0 from "./shopmanagement.vue?vue&type=style&index=0&id=231e3876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e3876",
  null
  
)

export default component.exports